<template>
  <v-expansion-panel
    :bg-color="bgColor"
    class="so-expansion-panel"
    elevation="0"
    data-testid="expansion-panel"
    @group:selected="$emit('clicked', $event)"
  >
    <v-expansion-panel-title
      data-testid="sp-expand-personal-details"
      class="align-center py-2"
      :class="noPadding ? 'px-0' : 'px-2'"
    >
      <slot name="title"></slot>
      <template v-if="$slots.actions" #actions="{ expanded }">
        <slot name="actions" :expanded="expanded"></slot>
      </template>
    </v-expansion-panel-title>
    <div
      v-if="$slots.alwaysVisible"
      :class="noPadding ? 'px-0' : 'px-2'"
      data-testid="visible-content"
    >
      <slot name="alwaysVisible"></slot>
    </div>
    <v-expansion-panel-text
      data-testid="expandable-content"
      :class="noPadding ? 'pa-0' : 'px-2 py-0'"
    >
      <slot></slot>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      bgColor: {
        type: String,
        default: "",
      },
      noPadding: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["clicked"],
  })
</script>

<style lang="css" scoped>
  :deep(button:focus-visible) {
    outline: var(--theme-outline);
    border-radius: var(--theme-radius);
  }

  :deep(.v-expansion-panel-title__overlay) {
    opacity: 0 !important;
  }

  :deep(.v-expansion-panel-title) {
    font-size: 1.125rem;
    font-weight: 500;
    line-height: 1.5;
    min-height: 0 !important;
  }

  :deep(.v-expansion-panel-text__wrapper) {
    padding: 0;
  }
</style>
